/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { GalleryCarouselIcon as icon } from '../../components/Icons';
import styles from './inline-styles';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Slider' ),
	description: __( 'Gutenify slider.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Gallery Carousel' ),
		__( 'Gallery' ),
		__( 'Carousel' ),
		__( 'Slider' ),
		__( 'Sliders' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		align: [ 'center', 'wide', 'full' ],
	},
	gutenify: {
		customStylesCallback( props ) {
			return styles( props );
		},
	},
};

export { name, category, settings };
